<template>
  <div class="review-page">
    <div class="review-page--content">
      <div class="text-center" v-if="loading">
        <b-spinner variant="primary" />
      </div>
      <b-container v-else>

      </b-container>
    </div>
  </div>
</template>

<script>

import {get_review_by_travel_review_id} from '@/api'

export default {
  name: 'review-redirect',
  components: {
  },
  props:{
    travel_review_id: String,
    secret: String,
    noTrack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      quote: {},
      request: {},
      quote_cover: '',
    }
  },
  computed: {
  },
  created()
  {
  },
  mounted() {
    this.log('[review-redirect.vue] - mounted()')

    let payload = {
      travel_review_id: this.travel_review_id,
      secret: this.secret,
      noTrack: this.noTrack,
    }

    get_review_by_travel_review_id(payload)
        .then((response) => {

          let params = {
            request_id: response.request_id,
            secret: response.secret,
          }

          if(this.noTrack) params.noTrack = this.noTrack

          this.$router.push({
            name: 'proposta',
            params: params
          })

        })
  },
  methods:{
  },
}
</script>

<style lang="scss">

</style>